import React, { useContext, useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { Card, Row, Container, Col, Button, Modal } from 'react-bootstrap';
import "./Event.css"
import { apiDeleteEventById, apiBookmarkEvent, apiUnbookmarkEvent } from '../api/api'
import { EventContext } from './EventContext'
import BgImg from '../img/placeholder.png'
import { ReactComponent as LocationIcon } from '../img/location.svg'
import { ReactComponent as PriceIcon } from '../img/price.svg'
import { ReactComponent as BookmarkBlankIcon } from '../img/bookmark-blank.svg'
import { ReactComponent as BookmarkFilledIcon } from '../img/bookmark-filled.svg'
import { ReactComponent as ShareIcon } from '../img/share.svg'
import { IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EventRounded } from '@mui/icons-material';

const Event = () => {
  let navigate = useNavigate()
  let { id } = useParams()
  const { userData, eventData, isLoaded, fetchEventData, setUserData } = useContext(EventContext)
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState("")

  const dateTimeFormat = (dateTime) => {
    let date = new Date(dateTime).toLocaleString('id', 
    {day: 'numeric', month: 'short', year: 'numeric'});
    let time = new Date(dateTime).toLocaleTimeString('en-US', 
    { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' });
    return date + " " + time
  }
  const priceFormat = (price) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'IDR'
    });
    if (price === 0)
        return '-'
    return formatter.format(price).substring(4,)
  }
  const contactFormat = (contact) => {
    let res = 'Contact: +62' + contact;
    if (contact === 0)
        return 'Contact: -'
    return res
  }

  const handleEventBookmark = (id) =>{
    apiBookmarkEvent(id)
		let eventEnrolled = userData.eventEnrolled
		eventEnrolled.push(id)
		setUserData((userData)=>({...userData, eventEnrolled}))
    fetchEventData(id)
    console.log(userData.eventEnrolled)
  }

  const handleEventUnbookmark = (id) =>{
		apiUnbookmarkEvent(id)
		let eventEnrolled = userData.eventEnrolled.filter(item => {
      return item !== id;
    })
		setUserData((userData)=>({...userData, eventEnrolled}))
		fetchEventData(id)
		console.log(userData.eventEnrolled)
  }

	const handleDelete = async (event) => {
		event.preventDefault()
		apiDeleteEventById(id).then((res) => {
			navigate(`/explore`)
		}).catch(error => {
			console.log(error.response)
			if (error.response !== undefined) {
				alert("Something went wrong, check console! ===>" 
								+ error.response.data.detail)
			} else {
				alert("Something went wrong")
			}
		})
	}

	const shareEvent = () => {
    let url = `${window.location.host}/event/${id}` 
    navigator.clipboard.writeText(url)
    setSnackbarMessage("Event URL copied to clipboard")
    handleSnackbarOpen()
  }

	const handleSnackbarOpen = () =>{
    setSnackbarOpen(true)
    setTimeout(() => setSnackbarOpen(false),5000)
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  }

	const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackbarClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  useEffect(() => {
    fetchEventData(id)
    console.log(userData.eventEnrolled)
  }, [])

  return (
    <div className='event'>
			<Container>
				<Card className='event-card'>
					{eventData && eventData.image ?
						<Card.Img className='event-card-image' 
											variant="top" 
											src={eventData.image} />
						:
						<Card.Img className='event-card-image' 
											variant="top" 
											src={BgImg} />
					}
					<div className='event-datetime-container'>
						<div className='event-datetime'>
							{dateTimeFormat(eventData.dateTime)}
						</div>  
					</div>
					<div>
						<Card.Body className='event-card-body'>
						<Row>
							<Col>
								<Card.Title className='event-card-title'>{eventData.name}</Card.Title>
								<Card.Text>
									<LocationIcon className='event-location' title="location"/>
									{eventData.location}
								<br/>
									<PriceIcon className='event-price' title="price"/>
									{priceFormat(eventData.price)}
								</Card.Text>
							</Col>
							<Col className='event-organizer-button'>
								{userData.email === eventData.organizer ?
									<div>
										<Link to={`/event/${id}/update`}>
											<Button variant="warning"
												className="edit-event-button"
												data-testid="edit-event-button">
												Edit
											</Button>
										</Link>
										<div>
											<Button variant="dark"
												className="delete-event-button"
												data-testid="delete-event-button"
												onClick={handleShow}>
												Delete
											</Button>
											<Modal show={show} onHide={handleClose}>
												<Modal.Header closeButton>
													<Modal.Title>Are you sure you want to delete this event?</Modal.Title>
												</Modal.Header>
												<Modal.Footer>
													<Button data-testid="cancel-delete-event"
														variant="secondary"
														onClick={() => { handleClose() }}>
														Cancel
													</Button>
													<Button data-testid="confirm-delete-event"
														variant="danger"
														onClick={handleDelete}>
														Delete
													</Button>
												</Modal.Footer>
											</Modal>
										</div>
									</div> :
									null
								}
							</Col>
						</Row>
						<Row>
							<Col xs="8">
								<Card.Text>
									{eventData.description}
								</Card.Text>
							</Col>
							<Col className='event-information'>
								
								<div className='event-button'>
									{userData.eventEnrolled.includes(id) ?
									<BookmarkFilledIcon onClick={() => {handleEventUnbookmark(id)}}
																			className='bookmark-event-filled' 
																			title="unbookmark" 
																			data-testid="bookmark-filled-comment" />
									:
									<BookmarkBlankIcon onClick={()=>{handleEventBookmark(id)}} 
																			className='bookmark-event-blank' 
																			title="bookmark" 
																			data-testid="bookmark-blank-comment" />
									}
									<ShareIcon className='share-event' 
															title="share event" 
															data-testid="share" 
															onClick={shareEvent}
															/>
								</div>
								<Card.Text >
									<div className='event-information-text'>For More Information:</div>
									{contactFormat(eventData.contact)}
									<br/>
									URL: <a href={eventData.link} target="_blank">{eventData.link}</a>
								</Card.Text>
							</Col>
						</Row>
						</Card.Body>  
					</div>
				</Card>
			</Container>
			<Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        action={action}
      />
    </div>
  )
}

export default Event